import request from '@/utils/request'

/**
 * 短信模板列表
 * POST /system/smsTemplate/list
 */
export function getSmsTemplateList(data) {
  return request({
    url: '/system/smsTemplate/list',
    method: 'post',
    data
  })
}

/**
 * 查询短信模板审核状态
 * GET /system/smsTemplate/queryStatus
 */
export function queryStatus(templateId) {
  return request({
    url: '/system/smsTemplate/queryStatus',
    method: 'get',
    params: { templateId }
  })
}

/**
 * 新增短信模板
 * POST /system/smsTemplate/add
 */
export function addSmsTemplate(data) {
  return request({
    url: '/system/smsTemplate/add',
    method: 'post',
    data
  })
}

/**
 * 删除短信模板
 * DELETE /system/smsTemplate/delete
 */
export function delSmsTemplate(templateId) {
  return request({
    url: '/system/smsTemplate/delete',
    method: 'delete',
    params: { templateId }
  })
}

/**
 * 修改短信模板
 * PUT /system/smsTemplate/update
 */
export function updateSmsTemplate(data) {
  return request({
    url: '/system/smsTemplate/update',
    method: 'put',
    data
  })
}

/**
 * 发送短信
 * POST /system/smsTemplate/send
 */
export function sendSms(data) {
  return request({
    url: '/system/smsTemplate/send',
    method: 'post',
    data
  })
}
